'use strict';

var jsxRuntime = require('react/jsx-runtime');
require('react');
var ErrorBoundary = require('./ErrorBoundary.js');

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function withErrorBoundary(Component) {
    return function WithErrorBoundary(props) {
        return /*#__PURE__*/ jsxRuntime.jsx(ErrorBoundary, {
            children: /*#__PURE__*/ jsxRuntime.jsx(Component, _extends({}, props))
        });
    };
}

module.exports = withErrorBoundary;
